import { Vue, Component } from 'vue-property-decorator';
import moment from "moment";

@Component
export default class DateCore extends Vue {

	// v format DD.MM.YYYY
	getWeekDayNumByDate(v: string): number {
		return /^([0-9]{2})\.([0-9]{2})\.([0-9]{4})$/g.test(v)
			? moment(v.split('.').reverse().join('-')).isoWeekday()
			: 0;
	}

	getWeekDayNameByISODate(v: string, prefix: string = ''): string {
		const i: number = moment(v).isoWeekday();

		return i ? ((prefix + this.$t('weekDays.' + i)) as string) : '';
	}

	getWeekDayName(v: string, prefix: string = ''): string {
		const i: number = this.getWeekDayNumByDate(v);

		return i ? ((prefix + this.$t('weekDays.' + i)) as string) : '';
	}

	getDateLocale(v: number): string {
		const d: Date = new Date(v);

		return d.getDate() + ' ' + this.$t(`month[${d.getMonth()}][0]`) + ' ' + d.getFullYear() + this.$t('date.yearShort');
	}

}